import createLucideIcon from '../createLucideIcon';

const Space = createLucideIcon('Space', [
  ['path', { d: 'M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1', key: 'lt2kga' }],
]);

export default Space;
